import React, { useEffect, useRef, useState } from "react";
import { Box, Button, CircularProgress, Grid, Paper, MenuItem, Typography , Chip } from "@mui/material";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { toast } from 'react-toastify';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from "moment";
import { Modal , Row , Col } from "react-bootstrap";

export default function ShiftCalls() {
	const [loading, setLoading] = useState(false);
	const [data , setData] = useState([]);
	const [show, setShow] = useState(false);
	const [blastMsg , setBlastMsg] = useState('');

	let loadData = () => {
		setLoading(true);
		ApiService.get('/myShiftCalls')
			.then(({ data }) => {
				setLoading(false);
				setData(data?.data)
			})
			.catch((e) => {
				setLoading(false);
				toast.error(e.response.data.message || 'Error')
			})
	}

	useEffect(() => {
		loadData()
	}, [])

	const handleShiftCalls = (row , status) => {
		ApiService.post("/changeShiftCallStatus", {
			Shift_Call_Id: row?.ID,
			Status : status ,
		})
			.then((data) => {
				toast.success(data?.message)
				loadData()
			})
			.catch(({ data }) => {
				toast.error(data?.message)
			});
	};

	return (
		<>
			<ManagementHeaderNav />
			<Box style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					<Grid item xs={12}>
						<Paper className="p-3">
							<Typography variant="h6">My Shift Calls</Typography>
								{loading &&
									<Box className="w-100 d-flex justify-content-center align-items-center py-4"
										style={{ height: '590px' }}>
										<CircularProgress />
									</Box>
								}
								{!loading && 
									<Box>
										{!loading && (
											<Box
												sx={{
													maxWidth: "93vw",
													overflowX: "auto",
													background: "#FFF",
												}}
											>
												<Grid container spacing={2} className='mt-2 mb-3'>
													{data?.length > 0 ? data?.map((item) => (
														<Grid item xs={4}>
															<Box
																sx={{
																	padding: '16px',
																	backgroundColor: '#ffffff',
																	borderRadius: '12px',
																	border: '1px solid #EBECF0',
																	boxShadow: `
																	0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
																	0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
																	0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
																`,
																}}
															>
																<TableContainer>
																	<Table aria-label="simple table">
																		<TableHead>
																			<TableRow>
																				<TableCell align="left" style={{ padding: '0px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' , display:'flex' , justifyContent:'space-between' }}>
																					<p>Date : {moment(item?.Shift_Date).format('MM/DD/YYYY')}</p>
																					<p>{item?.Shift_Code	== '2' ? 'Day' : 'Night'}</p>				
																				</TableCell>
																			</TableRow>
																		</TableHead>
																		<TableBody>
																			<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
																				<TableCell
																					component="th"
																					scope="row"
																					style={{
																						padding: '0px',
																						fontSize: '14px',
																						fontFamily: 'karla',
																						padding: '7px',
																						color: '#555555'
																					}}
																				>
																					
																					<p style={{ marginBottom: '3px' }}>Status :
																						<span style={{ color: '#000000', textTransform:'capitalize' }}> {item?.Status}</span>
																					</p>

																					{item?.blast_fill && 
																						<p>Shift expire on : <span style={{color:'#000000'}}>
																							{moment(item?.blast_fill?.Blast_Time).format('MM/DD/YYYY hh:mm:ss')}
																						</span></p>
																					}

																					<div style={{display:'flex' , justifyContent:'space-between'}}>
																						<div>
																							{item?.Status == 'pending' ? (
																								<div style={{marginTop: item?.blast_fill ? '10px' : '55px'}}>
																									<ButtonTheme
																										color="DarkGreen"
																										className="rounded-2"
																										onClick = {() => handleShiftCalls(item , 'accepted')}
																									>
																										Accept
																									</ButtonTheme>
																									<ButtonTheme
																										color="red"
																										className="rounded-2 mx-2"
																										onClick = {() => handleShiftCalls(item , 'rejected')}
																									>
																										Reject
																									</ButtonTheme>
																									<div>
																							</div>
																								</div>
																							) : (
																								<div style={{marginTop: item?.blast_fill ? '12px' : '48px'}}>
																									<ButtonTheme
																											style={ 
																												item?.Status =='accepted'?
																													{ backgroundColor: 'rgba(1, 120, 79, 0.1)', color: 'rgba(1, 120, 79, 1)', border: '1px solid rgba(1, 120, 79, 1)', cursor: 'auto', textTransform: 'capitalize' }
																													:
																													{ backgroundColor: 'rgba(230, 39, 25, 0.1)', color: 'red', border: '1px solid red', cursor: 'auto', textTransform: 'capitalize' }
																											}
																											className="rounded-2"
																									>
																										{item?.Status}
																									</ButtonTheme>
																								</div>
																							)}
																						</div>

																						{item?.blast_fill && 
																							<div style={{display:'flex'}}>
																								<Chip
																									sx={{
																										'& .MuiChip-label': {
																											display: 'block',
																											whiteSpace: 'normal',
																										},
																									}}
																									style={{
																										textAlign: 'center',
																										width:'80px',
																										padding: '6px 0px',
																										marginTop: item?.blast_fill ? '16px' : '52px' ,
																										backgroundColor: 'rgba(230, 39, 25, 0.2)',
																										border:'1px solid rgba(230, 39, 25, 0.3)',
																										color: '#000000',
																										cursor: 'pointer',
																									}}
																									label='Blast Fill'
																								/>
																								<div style={{marginLeft:'10px' , marginTop: item?.blast_fill ? '20px' : '58px' , cursor:'pointer'}} 
																									onClick={()=> {
																										setShow(true) 
																										setBlastMsg(item?.blast_fill?.Message)
																									}}
																								>
																									<img src="/images/message.svg" height='20px' width='20px' />
																								</div>
																							</div>
																						}
																						
																					</div>
																				</TableCell>
																			
																			</TableRow>
																		</TableBody>
																	</Table>
																</TableContainer>
															</Box>
														</Grid>
													))
												:
												  <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 570, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 185, width: 230 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Shift Found
                              </span>
                            </div>}
												</Grid>
											</Box>
										)}
									</Box>
								}
						</Paper>
					</Grid>
				</Grid>
			</Box>

			<Modal show={show} size="md"
				onHide={() => { setShow(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Blast Message</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
						<div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
							{blastMsg || 'No Blast Message'}
						</div>
					</Row>
				</Modal.Body>
			</Modal>
		</>)
}
